import { Component, EventEmitter, Input, OnInit, Output, OnChanges, inject } from '@angular/core';
import { Patient } from '../../../core/models/patient.model';
import { Prescriber } from '../../../core/models/prescriber.model';
import { PatientService } from '../../../core/services/patient.service';
import { MinimalProvider } from '../../../core/models/minimal-provider.model';

import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { PrescriberNameComponent } from '../../../shared/components/prescriber-name/prescriber-name.component';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { PrescriberListComponent } from '../prescriber-list/prescriber-list.component';

@Component({
    selector: 'app-select-prescriber',
    templateUrl: './select-prescriber.component.html',
    styleUrls: ['./select-prescriber.component.scss'],
    imports: [MatProgressSpinner, PrescriberNameComponent, FaIconComponent, PrescriberListComponent]
})
export class SelectPrescriberComponent implements OnInit, OnChanges {
  private patientService = inject(PatientService);

  prescribers: Prescriber[] = new Array<Prescriber>();
  refreshing = false;

  @Input() selectedPatient: Patient;
  @Input() selectedProvider: MinimalProvider;

  @Output() public selectionChange = new EventEmitter<Prescriber>();

  ngOnInit() {}

  ngOnChanges() {
    if (this.selectedPatient) {
      this.loadPatientPrescribers();
    } else {
      this.prescribers = new Array<Prescriber>();
    }
  }

  loadPatientPrescribers() {
    this.refreshing = true;

    this.patientService.getPrescribers(this.selectedPatient.id).subscribe((prescribers: Prescriber[]) => {
      this.prescribers = prescribers;
      this.refreshing = false;
    });
  }

  onPrescriberSelect(prescriber: Prescriber) {
    this.prescribers = new Array<Prescriber>();
    this.selectionChange.emit(prescriber);
  }

  onPrescriberClear() {
    this.prescribers = new Array<Prescriber>();
    this.selectionChange.emit(null);
  }
}
